/* Thin fetch wrapper: same-origin credentials, JSON bodies, FormData for uploads,
   and {error} payloads surfaced as Error objects with .status. */

async function request(path, { method = "GET", body } = {}) {
  const opts = { method, credentials: "same-origin", headers: {} };
  if (body instanceof FormData) {
    opts.body = body; // multipart — the browser sets the boundary
  } else if (body !== undefined) {
    opts.headers["content-type"] = "application/json";
    opts.body = JSON.stringify(body);
  }
  let res;
  try {
    res = await fetch(path, opts);
  } catch (err) {
    /* fetch only rejects on transport failures: offline, connection reset, blocked. */
    const wrapped = new Error("Could not reach the server — check your connection and try again.");
    wrapped.cause = err;
    throw wrapped;
  }
  const isJson = (res.headers.get("content-type") || "").includes("application/json");
  const payload = isJson ? await res.json().catch(() => ({})) : await res.text();
  if (!res.ok) {
    const err = new Error(payload.error || "Something went wrong");
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const api = {
  me: () => request("/api/me"),
  emailStart: email => request("/api/auth/email/start", { method: "POST", body: { email } }),
  emailVerify: (email, code) => request("/api/auth/email/verify", { method: "POST", body: { email, code } }),
  google: credential => request("/api/auth/google", { method: "POST", body: { credential } }),
  signOut: () => request("/api/auth/signout", { method: "POST" }),

  scans: (limit, offset) => request(`/api/scans?limit=${limit || 20}&offset=${offset || 0}`),
  createScan: formData => request("/api/scans", { method: "POST", body: formData }),
  scan: id => request(`/api/scans/${id}`),
  scanResults: id => request(`/api/scans/${id}/results`),
  deleteScan: id => request(`/api/scans/${id}`, { method: "DELETE" }),
  demo: withSerp => request("/api/demo", { method: "POST", body: { withSerp: !!withSerp } }),

  saveDfs: (login, password, location) => request("/api/me/dataforseo", { method: "PUT", body: { login, password, location } }),
  removeDfs: () => request("/api/me/dataforseo", { method: "DELETE" }),
  logs: (limit, offset) => request(`/api/logs?limit=${limit || 50}&offset=${offset || 0}`),
};
